module.exports = __webpack_public_path__ + "img/USAID_hz_rgb.db0d0c92.png";